export const nonceStorageKey = "dropbox.auth.nonce";